import { Stack, Typography } from '@mui/material'
import { AccountBalanceWalletOutlined } from '@mui/icons-material'

import { numericUtils } from '@/utils/numeric'

interface UseWalletBalanceInfoProps {
  amount: number
  balance: number
}

export const UseWalletBalanceInfo: React.FC<UseWalletBalanceInfoProps> = ({ amount, balance }) => {
  return (
    <Stack direction="row" alignItems="center" spacing={1.5}>
      <AccountBalanceWalletOutlined color="primary" sx={{ fontSize: 28 }} />
      <Stack width="100%">
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Você possui em saldo na carteira:
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="primary">
            {numericUtils.formatNumberToBRLCurrency(Number(balance))}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Valor da carteira a ser utilizado:
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="error">
            {numericUtils.formatNumberToBRLCurrency(Math.min(Number(amount), Number(balance)))}
          </Typography>
        </Stack>
        <Stack direction="row" alignItems="center" justifyContent="space-between" spacing={0.5}>
          <Typography variant="body2" color="text.secondary">
            Saldo na carteira após pagamento:
          </Typography>
          <Typography variant="body2" fontWeight="bold" color="success">
            {numericUtils.formatNumberToBRLCurrency(Math.max(0, Number(balance) - Number(amount)))}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  )
}
